import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComponentProductCarouselComponent } from './component-product-carousel.component';
import { CarouselModule } from 'primeng/carousel';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { PipeModule } from 'src/app/pipe/pipe.module';



@NgModule({
  declarations: [
    ComponentProductCarouselComponent
  ],
  imports: [
    CommonModule,
    CarouselModule,
    RouterModule,
    ButtonModule,
    PipeModule
  ],
  exports:[
    ComponentProductCarouselComponent
  ]
})
export class ComponentProductCarouselModule { }
